// ✅ central role definitions

export const ROLES = {
  ADMIN: "ADMIN",
  HR: "HR",
  DEVELOPER: "DEVELOPER",
  TESTER: "TESTER",
};

// ✅ who can create projects
export const canCreateProject = (role) =>
  role === ROLES.ADMIN || role === ROLES.HR;

// ✅ who can manage users
export const canManageUsers = (role) =>
  role === ROLES.ADMIN || role === ROLES.HR;